import React from 'react';
import { Info } from 'lucide-react';
import { Skeleton } from './ui/skeleton';

const FormSkeleton = (props) => {
	return (
		<div
			className="flex flex-col text-center items-center justify-items-center"
		>
			{props.apiError ? (
				<div className="flex flex-col text-center items-center justify-items-center">
					<Info color={props.errorColor} size={90} />
					<h3 className="text-center md:text-5xl text-4xl py-5">
						{props.apiErrorMessage}
					</h3>
					<p className="text-center text-2xl pt-5">
						Please try again or contact support@chekkit.io
					</p>
				</div>
			) : (
				<div className="flex flex-col space-y-3">
					<Skeleton className="w-[150px] h-[40px] rounded-full" />
					<Skeleton className=" w-[400px] md:w-[600px] h-[40px] rounded-xl" />
					<Skeleton className=" w-[400px] md:w-[600px] h-[40px] rounded-xl" />
					<Skeleton className=" w-[150px] md:w-[200px] h-[20px] rounded-xl" />
					<Skeleton className=" w-[150px] md:w-[200px] h-[20px] rounded-xl" />
				</div>
			)}
		</div>
	);
};

export default FormSkeleton;
